import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions, selectors } from '../../store/dux/early-season-fungicide-dux';
import { selectors as growerSelectors } from '../../store/dux/grower-dux';
import {
  selectors as fieldSelectors,
  actions as fieldActions,
} from '../../store/dux/fields-dux';
import ResizablePanel from '../../components/Resizeable/ResizablePanel';
import EarlySeasonFungicideTable from './components/EarlySeasonFungicideTable';
import EarlySeasonFungicideMap from './EarlySeasonFungicideMap';
import { Section } from '../Section';

function EarlySeasonFungicide() {
  const dispatch = useDispatch();
  const fields = useSelector(selectors.fields);
  const isLoading = useSelector(selectors.isLoading);
  const selectedFields = useSelector(fieldSelectors.selectedFields);
  const growerId = useSelector(growerSelectors.selectedId);
  const reloadFields = useCallback(reloadFieldsCallback, [dispatch, growerId]);

  useEffect(initEffect, [reloadFields]);

  function initEffect() {
    reloadFields();
  }

  function reloadFieldsCallback() {
    if (growerId) dispatch(actions.loadEarlySeasonFungicide(growerId));
  }

  function handleSelectFields(fieldsSelected) {
    dispatch(fieldActions.setSelectedGrowerFields(fieldsSelected));
  }

  return (
    <Section>
      <ResizablePanel
        topPanel={
          <EarlySeasonFungicideMap handleSelectFeatures={handleSelectFields} />
        }
        bottomPanel={
          <EarlySeasonFungicideTable
            loading={isLoading}
            growerId={growerId}
            fields={fields}
            selectedFields={selectedFields}
            reloadFields={reloadFields}
          />
        }
      />
    </Section>
  );
}

export default EarlySeasonFungicide;
